import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { BundleDetailsComponent } from './bundle-details.component';
import { LineItemListModule } from '../line-item-list/line-item-list.module';

@NgModule({
  declarations: [
    BundleDetailsComponent
  ],
  imports: [
    SharedModule,
    LineItemListModule
  ],
  exports: [
    BundleDetailsComponent
  ],
  providers: []
})
export class BundleDetailsModule { }
